module.exports = __webpack_public_path__ + "static/media/admin.3c76f1ad.svg";